var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"rotate-chevron",class:{ [_vm.direction]: true },attrs:{"viewBox":"0 0 256 512"}},[_c('path',{attrs:{"d":"M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }